// extracted by mini-css-extract-plugin
module.exports = {"invite":"AssigneeSelectorWorkflowInvoices_invite___Y2tR"};